import ReactDOM from 'react-dom'
import Root from './containers/Root';

ReactDOM.render(
  <Root />,
  document.getElementById('root'),
)
